import dayjs from 'dayjs';
import isNil from 'lodash/isNil';
import orderBy from 'lodash/orderBy';
import { TPaymentPeriodList } from '../types/payment-data-types';

export function sortPaymentPeriodsByDate(
  data: TPaymentPeriodList,
  order?: any, // See https://lodash.com/docs/4.17.15#orderBy
) {
  const orderByOrder = isNil(order) ? ['desc'] : order;
  return orderBy(data, (datum) => dayjs(datum.startDate).unix(), orderByOrder);
}
